import script from "./TourComponet.vue?vue&type=script&setup=true&lang=js"
export * from "./TourComponet.vue?vue&type=script&setup=true&lang=js"

import "./TourComponet.vue?vue&type=style&index=0&id=3513ef86&lang=css"

const __exports__ = script;

export default __exports__